import React from "react"

import StatusSummaryBar from "../table/calculated/summary"
import FieldProto from "../../../../proto/field-proto"
import Board_AggregateShell from "../../../../../gd-modules/tasks-view/board/components/aggregate/aggregate-shell"
import Board_Manager from "../../../../../gd-modules/tasks-view/board/managers/manager"

type Props = {
    className       : string

    manager         : Board_Manager
    field           : FieldProto

    calculatedData  : {
        own             : {summary: Record<ID, number>}
        children        : {summary: Record<ID, number>}
        total           : {summary: Record<ID, number>}

        hasOwnValue     : boolean
        hasChildren     : boolean
    }
}

// const debug = "FieldStatus_BoardAggregate"
const debug = false

export default function FieldStatus_BoardAggregate(props: Props) {

    const value = props.calculatedData?.total.summary
    const isValid = !_.isNil(value) && !_.isNaN(value)

    debug && console.log(debug, 'render', value)

    const showLine = isValid && !_.isEmpty(value)
    const classes = Classes("max-w-100", props.className, {
        'w-100p'        : showLine,
        'show-on-hover' : !showLine
    })

    return (
        <Board_AggregateShell
            className   = {classes}
            manager     = {props.manager}
        >
            {!showLine &&
                <div className="flex-row-left-center">
                    <div className={Classes("ui5-ico-12 m-r-5 m-t-1", props.field.icon)}/>
                </div>}

            {showLine &&
                <div className="flex-row-left-center w-100p">
                    <StatusSummaryBar data={value}/>
                </div>}
        </Board_AggregateShell>
    )
}
